module.exports = __webpack_public_path__ + "static/media/elixer.a5fecbd0.svg";